import type { ReactNode } from "react";

import { NavBar } from "./NavBar";
import { ResourceBar } from "./ResourceBar";
import styles from "./AppShell.module.css";

export interface AppShellProps {
  children: ReactNode;
  chrome?: boolean;
}

export function AppShell({ children, chrome = true }: AppShellProps): JSX.Element {
  return (
    <div className={styles.shell}>
      {chrome && <NavBar />}
      {chrome && <ResourceBar />}
      <main className={styles.content}>{children}</main>
    </div>
  );
}
